//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
let d=[[],[[["fileName"],"ExecuteMacro",{},1,0],[["fileName"],"UIAutotestExecuteMacro",{},1,0],[[],"AutotestExpandAllInAnav",{},0,0],[[],"AutotestExpandAllInCnav",{},0,0],[["policy"],"SetValidationPolicy",{},1,0],[["save"],"SetDialogMemorySaveOption",{},1,0],[["fileName","runCount"],"RunDialogLaunchPerformanceTest",{},2,0]],[["Templates","UITemplateTestManager",0]]];
SPLM.DebugUI = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DebugUI";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DebugUI.ValidationPolicy = Object.freeze({
    "Standard" : "Standard", "Strict" : "Strict"});

export default SPLM;